export default __webpack_public_path__ + "static/media/xtusd-logo-ellipse-transparent-260x260.27084b28.svg";